import React, { Component, Suspense } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import Cookies from 'js-cookie';
import MediaQuery from 'react-responsive';
import { modalsActions } from '../../actions';
import MODALS from '../../constants/modals';
import styles from './Modals.module.sass';
import ReactModal from './ReactModal';
import { currentModalSelector, dataSelector } from '../../selectors/modals';
import { userObjectSelector } from '../../../user/selectors/user';
import locationService from '../../../services/location_service';

const SignIn = React.lazy(() => import('./sign_in/SignIn'));
const SignUp = React.lazy(() => import('./sign_in/SignUp'));
const SignUpConfirmation = React.lazy(() => import('./sign_in/SignUpConfirmation'));
const ResendSignUpConfirmation = React.lazy(() => import('./sign_in/ResendSignUpConfirmation'));
const ForgotPassword = React.lazy(() => import('./sign_in/ForgotPassword'));
const ForgotPasswordSent = React.lazy(() => import('./sign_in/ForgotPasswordSent'));
const WelcomePromotion = React.lazy(() => import('./sign_in/WelcomePromotion'));
const Image = React.lazy(() => import('./image/Image'));
const ImageWithZoom = React.lazy(() => import('./image_with_zoom/ImageWithZoom'));
const ImagesSlider = React.lazy(() => import('./images_slider/ImagesSlider'));
const Information = React.lazy(() => import('./information/Information'));
const Vote = React.lazy(() => import('./vote/Vote'));
const RemoveCreditCard = React.lazy(() => import('./remove_credit_card/RemoveCreditCard'));
const QuizFinished = React.lazy(() => import('./quiz_finished/QuizFinished'));
const InnovatorInfoSubmitted = React.lazy(() => import('./innovator_info_submitted/InnovatorInfoSubmitted'));
const CampaignPassword = React.lazy(() => import('./campaign_password/CampaignPassword'));
const CancelSubscription = React.lazy(() => import('./cancel_subscription/CancelSubscription'));
const RedeemGiftCard = React.lazy(() => import('./redeem_gift_card/RedeemGiftCard'));
const PurchaseGiftCard = React.lazy(() => import('./purchase_gift_card/PurchaseGiftCard'));
const ExtendedSignUp = React.lazy(() => import('./extended_sign_up/ExtendedSignUp'));
const CheckOutTheLounge = React.lazy(() => import('./check_out_the_lounge/CheckOutTheLounge'));
const JoinTheLounge = React.lazy(() => import('./join_the_lounge/JoinTheLounge'));
const RegimenSent = React.lazy(() => import('./regimen_sent/RegimenSent'));
const ForbiddenIngredients = React.lazy(() => import('./forbidden_ingredients/ForbiddenIngredients'));

const DESKTOP_WIDTH_BREAKPOINT = 600;

const trackFirstVisitTime = () => {
  if (Cookies.get('first_visit_time')) { return; }

  Cookies.set('first_visit_time', Date.now());
};

class Modals extends Component {
  componentDidMount() {
    Modal.setAppElement('#react-modals');
    trackFirstVisitTime();
    this.showWelcomePromotionModal();
    // this.showSignUpModal();
    this.showCampaignNotWinPopup();
    this.showCampaignProtectedModal();
    this.showSignInForProductSubscriptionModal();

    window.addEventListener('resize', this.onResize);
  }

  componentDidUpdate() {
    const { currentModal } = this.props;

    if (!currentModal
      || currentModal === MODALS.VOTING
      || currentModal === MODALS.REMOVE_CREDIT_CARD
      || currentModal === MODALS.IMAGE_WITH_ZOOM
      || currentModal === MODALS.CANCEL_SUBSCRIPTION
      || currentModal === MODALS.REDEEM_GIFT_CARD
      || currentModal === MODALS.CHECK_OUT_THE_LOUNGE
      || currentModal === MODALS.JOIN_THE_LOUNGE) {
      window.scrollService.enableScroll();
      return;
    }

    if (window.innerWidth < DESKTOP_WIDTH_BREAKPOINT) {
      window.scrollService.disableScroll();
    }
  }

  onResize = () => {
    const { currentModal } = this.props;

    if (!currentModal
      || currentModal === MODALS.VOTING
      || currentModal === MODALS.REMOVE_CREDIT_CARD
      || currentModal === MODALS.IMAGE_WITH_ZOOM
      || currentModal === MODALS.CANCEL_SUBSCRIPTION
      || currentModal === MODALS.REDEEM_GIFT_CARD
      || currentModal === MODALS.CHECK_OUT_THE_LOUNGE
      || currentModal === MODALS.JOIN_THE_LOUNGE) {
      return;
    }

    if (window.innerWidth >= DESKTOP_WIDTH_BREAKPOINT) {
      window.scrollService.enableScroll();
    } else {
      window.scrollService.disableScroll();
    }
  };

  showWelcomePromotionModal = () => {
    const { openModalRequest } = this.props;

    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const voteCode = urlParams.get('vote_code');
    const expiresAt = urlParams.get('expires_at');
    if (code) {
      openModalRequest({ modal: MODALS.WELCOME_PROMOTION, data: { code, expiresAt } });
    } else if (voteCode) {
      openModalRequest({
        modal: MODALS.WELCOME_PROMOTION_FROM_VOTING,
        data: { code: voteCode, expiresAt },
      });
    }
  };

  // showSignUpModal = () => {
  //   const DEFAULT_SIGN_UP_MODAL_DELAY_IN_SECONDS = 45;
  //   const firstVisitTime = Cookies.get('first_visit_time');
  //   const SIGN_UP_MODAL_DELAY_IN_SECONDS = (
  //     DEFAULT_SIGN_UP_MODAL_DELAY_IN_SECONDS - (
  //       firstVisitTime && Date.now() - firstVisitTime
  //     ) / 1000
  //   );

  //   const shouldNotShowSignUpModal = () => {
  //     const { user } = this.props;

  //     return user
  //       || Cookies.get('sign_up_popup_shown')
  //       || window.location.pathname.includes('/shop/checkout_now')
  //       || window.location.pathname.includes('/pages/join_us');
  //   };

  //   if (shouldNotShowSignUpModal()) { return; }

  //   const showSignUpModal = () => {
  //     if (shouldNotShowSignUpModal()) { return; }

  //     const { openModalRequest } = this.props;
  //     openModalRequest({ modal: MODALS.SIGN_UP });
  //   };

  //   setTimeout(showSignUpModal, SIGN_UP_MODAL_DELAY_IN_SECONDS * 1000);
  // }

  showCampaignNotWinPopup = () => {
    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.get('campaign_not_win')) { return; }

    const { openModalRequest } = this.props;
    openModalRequest({ modal: MODALS.CAMPAIGN_NOT_WIN });

    const closeCampaignNotWinPopup = () => {
      const { currentModal, closeModal } = this.props;
      if (currentModal !== MODALS.INFORMATION) { return; }
      closeModal();
    };

    setTimeout(closeCampaignNotWinPopup, 7000);
  };

  showCampaignProtectedModal = () => {
    const urlParams = new URLSearchParams(window.location.search);

    const campaignId = urlParams.get('protected_campaign_id');
    if (!campaignId) { return; }

    window.campaignPasswordSubmittedCallback = () => {
      window.location.href = `/campaigns/${campaignId}`;
    };

    const { openModalRequest } = this.props;
    openModalRequest({
      modal: MODALS.CAMPAIGN_PASSWORD,
      data: { campaignId: Number(campaignId) },
    });
  };

  showSignInForProductSubscriptionModal = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const { user } = this.props;

    if (!urlParams.get('show_sign_in_for_product_subscription') || user) { return; }

    const { openModalRequest } = this.props;
    openModalRequest({ modal: MODALS.SIGN_IN_FOR_PRODUCT_SUBSCRIPTION });
  };

  render() {
    const { currentModal, closeModal, embedApp } = this.props;
    return (
      <div className={styles.modals}>
        <ReactModal isOpen={currentModal === MODALS.SIGN_IN}>
          <Suspense>
            <SignIn embedApp={embedApp} />
          </Suspense>
        </ReactModal>

        <ReactModal isOpen={currentModal === MODALS.SIGN_UP}>
          <Suspense>
            <SignUp embedApp={embedApp} />
          </Suspense>
        </ReactModal>

        <ReactModal isOpen={currentModal === MODALS.SIGN_UP_CONFIRMATION}>
          <Suspense>
            <SignUpConfirmation />
          </Suspense>
        </ReactModal>

        <ReactModal isOpen={currentModal === MODALS.RESEND_SIGN_UP_CONFIRMATION}>
          <Suspense>
            <ResendSignUpConfirmation />
          </Suspense>
        </ReactModal>

        <ReactModal isOpen={currentModal === MODALS.FORGOT_PASSWORD}>
          <Suspense>
            <ForgotPassword />
          </Suspense>
        </ReactModal>

        <ReactModal isOpen={currentModal === MODALS.FORGOT_PASSWORD_SENT}>
          <Suspense>
            <ForgotPasswordSent />
          </Suspense>
        </ReactModal>

        <ReactModal isOpen={currentModal === MODALS.WELCOME_PROMOTION}>
          <Suspense>
            <WelcomePromotion />
          </Suspense>
        </ReactModal>

        <ReactModal isOpen={currentModal === MODALS.INFORMATION}>
          <Suspense>
            <Information />
          </Suspense>
        </ReactModal>

        <ReactModal isOpen={currentModal === MODALS.CAMPAIGN_PASSWORD}>
          <Suspense>
            <CampaignPassword closeModal={closeModal} />
          </Suspense>
        </ReactModal>

        <Modal
          isOpen={currentModal === MODALS.VOTING}
          onRequestClose={closeModal}
          overlayClassName={`${styles.overlay} ${styles.voting}`}
          className={`${styles.content} ${styles.voting}`}
        >
          <div className={styles.wrapper}>
            <Suspense>
              <Vote closeModal={closeModal} />
            </Suspense>
          </div>
        </Modal>

        <Modal
          isOpen={currentModal === MODALS.QUIZ_FINISHED}
          onRequestClose={locationService.goToQuiz}
          overlayClassName={styles.overlay}
          className={`${styles.content} ${styles['quiz-finished']}`}
        >
          <div className={styles.wrapper}>
            <Suspense>
              <QuizFinished closeModal={locationService.goToQuiz} />
            </Suspense>
          </div>
        </Modal>

        <Modal
          isOpen={currentModal === MODALS.INNOVATOR_INFO_SUBMITTED}
          onRequestClose={closeModal}
          overlayClassName={styles.overlay}
          className={`${styles.content} ${styles['quiz-finished']}`}
        >
          <div className={styles.wrapper}>
            <Suspense>
              <InnovatorInfoSubmitted closeModal={closeModal} />
            </Suspense>
          </div>
        </Modal>

        <Modal
          isOpen={currentModal === MODALS.IMAGE}
          onRequestClose={closeModal}
          overlayClassName={styles.overlay}
          className={`${styles.content} ${styles.image}`}
        >
          <div className={styles.wrapper}>
            <Suspense>
              <Image closeModal={closeModal} />
            </Suspense>
          </div>
        </Modal>

        <Modal
          isOpen={currentModal === MODALS.IMAGE_WITH_ZOOM}
          onRequestClose={closeModal}
          overlayClassName={styles.overlay}
          className={`${styles.content} ${styles.image}`}
        >
          <div className={styles.wrapper}>
            <Suspense>
              <ImageWithZoom closeModal={closeModal} />
            </Suspense>
          </div>
        </Modal>

        <Modal
          isOpen={currentModal === MODALS.IMAGES_SLIDER}
          onRequestClose={closeModal}
          overlayClassName={styles.overlay}
          className={`${styles.content} ${styles['images-slider']}`}
        >
          <div className={styles.wrapper}>
            <Suspense>
              <ImagesSlider closeModal={closeModal} />
            </Suspense>
          </div>
        </Modal>

        <MediaQuery query="(max-width: 819px)">
          <Modal
            isOpen={currentModal === MODALS.REMOVE_CREDIT_CARD}
            onRequestClose={closeModal}
            overlayClassName={styles.overlay}
            className={`${styles.content} ${styles['remove-credit-card']}`}
          >
            <div className={styles.wrapper}>
              <Suspense>
                <RemoveCreditCard closeModal={closeModal} />
              </Suspense>
            </div>
          </Modal>
        </MediaQuery>

        <Modal
          isOpen={currentModal === MODALS.CANCEL_SUBSCRIPTION}
          onRequestClose={closeModal}
          overlayClassName={styles.overlay}
          className={`${styles.content} ${styles['cancel-subscription']}`}
        >
          <div className={styles.wrapper}>
            <Suspense>
              <CancelSubscription closeModal={closeModal} />
            </Suspense>
          </div>
        </Modal>

        <Modal
          isOpen={currentModal === MODALS.REDEEM_GIFT_CARD}
          onRequestClose={closeModal}
          overlayClassName={styles.overlay}
          className={`${styles.content} ${styles['redeem-gift-card']}`}
        >
          <div className={styles.wrapper}>
            <Suspense>
              <RedeemGiftCard closeModal={closeModal} />
            </Suspense>
          </div>
        </Modal>

        <Modal
          isOpen={currentModal === MODALS.PURCHASE_GIFT_CARD}
          onRequestClose={closeModal}
          overlayClassName={styles.overlay}
          className={`${styles.content} ${styles['purchase-gift-card']}`}
        >
          <div className={styles.wrapper}>
            <Suspense>
              <PurchaseGiftCard closeModal={closeModal} />
            </Suspense>
          </div>
        </Modal>

        <Modal
          isOpen={currentModal === MODALS.CHECK_OUT_THE_LOUNGE}
          onRequestClose={closeModal}
          overlayClassName={`${styles.overlay} ${styles['join-the-lounge']}`}
          className={`${styles.content} ${styles['join-the-lounge']}`}
        >
          <div className={styles.wrapper}>
            <Suspense>
              <CheckOutTheLounge closeModal={closeModal} />
            </Suspense>
          </div>
        </Modal>

        <Modal
          isOpen={currentModal === MODALS.JOIN_THE_LOUNGE}
          onRequestClose={closeModal}
          overlayClassName={`${styles.overlay} ${styles['join-the-lounge-for-voting']}`}
          className={`${styles.content} ${styles['join-the-lounge-for-voting']}`}
        >
          <div className={styles.wrapper}>
            <Suspense>
              <JoinTheLounge closeModal={closeModal} />
            </Suspense>
          </div>
        </Modal>

        <Modal
          isOpen={currentModal === MODALS.REGIMEN_SENT}
          onRequestClose={closeModal}
          overlayClassName={styles.overlay}
          className={`${styles.content} ${styles['regimen-sent']}`}
        >
          <div className={styles.wrapper}>
            <Suspense>
              <RegimenSent closeModal={closeModal} />
            </Suspense>
          </div>
        </Modal>

        <Modal
          isOpen={currentModal === MODALS.EXTENDED_SIGN_UP}
          onRequestClose={closeModal}
          overlayClassName={styles.overlay}
          className={styles.content}
        >
          <div className={styles.wrapper}>
            <Suspense>
              <ExtendedSignUp closeModal={closeModal} />
            </Suspense>
          </div>
        </Modal>

        <Modal
          isOpen={currentModal === MODALS.FORBIDDEN_INGREDIENTS}
          onRequestClose={closeModal}
          overlayClassName={styles.overlay}
          className={styles.content}
        >
          <div className={styles.wrapper}>
            <Suspense>
              <ForbiddenIngredients closeModal={closeModal} />
            </Suspense>
          </div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentModal: currentModalSelector(state),
  data: dataSelector(state),
  user: userObjectSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  openModalRequest: (data) => dispatch(modalsActions.openModalRequest(data)),
  closeModal: () => dispatch(modalsActions.closeModal()),
});

Modals.propTypes = {
  currentModal: PropTypes.string,
  openModalRequest: PropTypes.func.isRequired,
  data: PropTypes.shape({
    name: PropTypes.string,
  }),
  user: PropTypes.shape({}),
  closeModal: PropTypes.func.isRequired,
  embedApp: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Modals);
